import { createSelector } from 'reselect';

const moduleSelector = state => state.auth;

export const getRegisterError = createSelector(moduleSelector, state => state.registerError);

export const getLoggedIn = createSelector(moduleSelector, state => state.loggedIn);
export const getLoggedInProcess = createSelector(moduleSelector, state => state.loggedInProcess);
export const getLoginError = createSelector(moduleSelector, state => state.loginError);

export const getUpdatePasswordProcess = createSelector(moduleSelector, state => state.updatePasswordPocess);

export const getPasswordForgotSentSelector = createSelector(moduleSelector, state => state.passwordForgotSent);
export const getPasswordForgotErrorSelector = createSelector(moduleSelector, state => state.passwordForgotError);

export const getPasswordResetOkSelector = createSelector(moduleSelector, state => state.passwordResetOk);
export const getPasswordResetErrorSelector = createSelector(moduleSelector, state => state.passwordResetError);
